import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import LazyPdfViewerPage from '../views/LazyPdfViewer/LazyPdfViewer';


const Channel = Loadable(lazy(() => import('views/Channel')));
const SearchPage = Loadable(lazy(() => import('views/Huggingface/SearchPage')));
const Log = Loadable(lazy(() => import('views/Log')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const User = Loadable(lazy(() => import('views/User')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

const Quota = Loadable(lazy(() => import('views/Quota')));
const Task  = Loadable(lazy(() => import('views/Task')));
const File  = Loadable(lazy(() => import('views/File')));

const PayQrcode = Loadable(lazy(() => import('views/PayQrcode')));
const PayOrder = Loadable(lazy(() => import('views/PayOrder')));
const SMS = Loadable(lazy(() => import('views/SMS')));
const SMSSettings = Loadable(lazy(() => import('views/SMS/Settings')));
const SMSHistory = Loadable(lazy(() => import('views/SMS/History')));
const SMSUserHistory = Loadable(lazy(() => import('views/SMS/UserHistory')));
const NoMark = Loadable(lazy(() => import('views/NoMark')));
const Client = Loadable(lazy(() => import('views/Client')));
const AdminRepo = Loadable(lazy(() => import('views/AdminRepo')));
const AdminTask = Loadable(lazy(() => import('views/AdminTask')));
const Profiles = Loadable(lazy(() => import('views/Profiles')));
const Proxies = Loadable(lazy(() => import('views/Proxies')));
const Node = Loadable(lazy(() => import('views/Node')));
const Ops = Loadable(lazy(() => import('views/Ops')));
const Ddns = Loadable(lazy(() => import('views/Ddns')));
const Manage = Loadable(lazy(() => import('views/Manage')));
const Download = Loadable(lazy(() => import('views/Download')));
// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <Dashboard />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'search',
      element: <SearchPage />

    },
    {
      path: 'task',
      element: <Task />
    },
    {
      path: 'file',
      element: <File />
    },
    {
      path: 'channel',
      element: <Channel />
    },
    {
      path: 'log',
      element: <Log />
    },
    {
      path: 'redemption',
      element: <Redemption />
    },
    {
      path: 'qrcode',
      element: <PayQrcode />
    },
    {
      path: 'payorder',
      element: <PayOrder />
    },

    {
      path: 'setting',
      element: <Setting />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'quota',
      element: <Quota />
    },
    {
      path: 'topup',
      element: <Topup />
    },
    {
      path: 'user',
      element: <User />
    },
    {
      path: 'manage',
      element: <Manage />
    },
    {
      path: 'download',
      element: <Download />
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: 'client',
      element: <Client />
    },
    {
      path: 'system-repo',
      element: <AdminRepo />
    },
    {
      path: 'user-repo',
      element: <AdminTask />
    },
    {
      path: 'profiles',
      element: <Profiles />
    },
    {
      path: 'proxies',
      element: <Proxies />
    },
    {
      path: 'node',
      element: <Node />
    },
    {
      // 运维：页内 Tab 容器（动态 DNS / 后续 nginx 管理等）
      path: 'ops',
      element: <Ops />
    },
    {
      // 保留独立入口，直接访问 /panel/ddns 仍可用（菜单已改指向 /panel/ops）
      path: 'ddns',
      element: <Ddns />
    },
    {
      path: 'sms',
      element: <SMS />
    },
    {
      path: 'sms-settings',
      element: <SMSSettings />
    },
    {
      path: 'sms-history',
      element: <SMSHistory />
    },
    {
      path: 'sms-user-history',
      element: <SMSUserHistory />
    },
    {
      path: 'nomark',
      element: <NoMark />
    },
    { path: "pdf-viewer",
      element: <LazyPdfViewerPage />
    },
    {
      path: '404',
      element: <NotFoundView />
    }
  ]
};

export default MainRoutes;
